import { render } from "./HeaderAdmin.partial.vue?vue&type=template&id=803c70ac&scoped=true"
import script from "./HeaderAdmin.partial.vue?vue&type=script&lang=js"
export * from "./HeaderAdmin.partial.vue?vue&type=script&lang=js"

import "./HeaderAdmin.partial.vue?vue&type=style&index=0&id=803c70ac&scoped=true&lang=css"

import exportComponent from "/Users/christianreyes/Documents/Proyectos/buzon/buzon-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-803c70ac"]])

export default __exports__